var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/video_icon_blue.0da96a1b.png","uri@2x": __webpack_public_path__ + "static/media/video_icon_blue.e8b044d9.png","uri@3x": __webpack_public_path__ + "static/media/video_icon_blue.16cd6195.png",
    width: 23,
    height: 16
});